import defaultApi from '@/utils/request';

export default { // 加載列表
  /*------------------------------------------------------*/
  S1YW2001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S11/S1Y/S1YW2001_Load',
      params,
    });
  },
  S1YW2001_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S11/S1Y/S1YW2001_Query',
      params,
    });
  },
  S1YW2001_getPagePdf(params) { // 列印頁面
    return defaultApi({
      method: 'get',
      url: 'S11/S1Y/S1YW2001_getPagePdf',
      responseType: 'blob',
      params,
    });
  },
  S1YW2001_updAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S11/S1Y/S1YW2001_updAction',
      data,
    });
  },
  S1YW2001_AttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S11/S1Y/S1YW2001_AttachmentViewFileUpload',
      data,
    });
  },
  S1YW2001_AttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S11/S1Y/S1YW2001_AttachmentViewFileDelete',
      data,
    });
  },
  /*------------------------------------------------------*/
  S1YW9001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S11/S1Y/S1YW9001_Load',
      params,
    });
  },
  S1YW9001_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S11/S1Y/S1YW9001_Query',
      params,
    });
  },
  S1YW9001_getPagePdf(params) { // 列印頁面
    return defaultApi({
      method: 'get',
      url: 'S11/S1Y/S1YW2001_getPagePdf',
      responseType: 'blob',
      params,
    });
  },
  /*------------------------------------------------------*/
};
